import { SchemaFactory } from '../core';
import { generateFormFieldValuesAndValidations } from '.';
import {
  FormField,
  FormInitialValues,
  FormValidations,
  DynamicFormData,
} from '../typings';

/**
 * Generates initial values and validation schema for a Formik form based on the provided form data.
 *
 * This function takes an array of form field data and generates initial values and a validation schema suitable for use with Formik.
 * It also returns the original form data as 'inputs'.
 *
 * @param formData - An array of form field data. Each object in the array represents a form field and should contain the necessary information to generate initial values and a validation schema for that field.
 * @returns An object containing initial values for the form, a validation schema, and the original form data. The initial values and validation schema are suitable for use with Formik.
 */
export const getDyanmicFormData = (
  formData?: FormField[],
): Partial<DynamicFormData> => {
  if (!formData) {
    return {};
  }

  let initialValues: FormInitialValues = {};
  let validationFields: FormValidations = {};

  for (const field of formData) {
    const result = generateFormFieldValuesAndValidations(
      field,
      initialValues,
      validationFields,
    );

    initialValues = { ...initialValues, ...result.initialValues };
    validationFields = { ...validationFields, ...result.validationFields };
  }

  return {
    initialValues,
    validationSchema: SchemaFactory.object().shape({ ...validationFields }),
    formFieldGroups: formData,
  };
};
